export var languages = [
  {code: 'hr', name: 'Croatian'},
  {code: 'en', name: 'English'},
  {code: 'de', name: 'German'},
  {code: 'fr', name: 'French'},
  {code: 'it', name: 'Italian'},
  {code: 'cs', name: 'Czech'},
];

